import $apiJSON from 'http/apiJSON'

const BASE = '/proctoring'

export const sendEvent = (formData) =>
  $apiJSON.post(`${BASE}/events/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })

export const sendJsonEvent = (payload) =>
  $apiJSON.post(`${BASE}/events/`, payload)

export const listEvents = (params = {}) =>
  $apiJSON.get(`${BASE}/events/`, { params })

export default {
  sendEvent,
  sendJsonEvent,
  listEvents,
}
